import axios from "axios"
import { create } from "zustand"

export const useAuthors = create((set, get) => ({
    cats: [],
    columns: [{
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
    }, {
        title: 'Nomi',
        dataIndex: 'fullname',
        key: 'fullname',
    }],
    setCat: (cats) => {
        axios.get('/bookautors')
            .then(res => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ cats: data });
            })
            .catch(err => {
                console.error('Mualliflarni yuklab olishda xatolik:', err);
                set({ cats: [] });
            })
    },
    addCat: (cat) => {
        axios.post('/bookautors', cat)
            .then(res => {
                get().setCat();
            })
            .catch(err => {
                console.error('Muallif qo\'shishda xatolik:', err);
            })
    },
    removeCat: (_, cat) => {
        axios.delete('/bookautors/' + cat.id)
            .then(res => {
                get().setCat();
            })
            .catch(err => {
                console.error('Muallif o\'chirishda xatolik:', err);
            })
    },
    updateCat: (cat) => {
        axios.put('/bookautors/' + cat.id, cat)
            .then(res => {
                get().setCat();
            })
            .catch(err => {
                console.error('Muallif taxrirlashda xatolik:', err);
            })
    },
    ed: null,
    setEd: (ed) => {
        set({ ed })
    }
}))